var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 28,
    viewBox: "0 0 116 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 5.5 23.5)",
    fill: "#303030"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 5.5 12.5)",
    fill: "#303030"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 5.5 1.5)",
    fill: "#303030"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 16.5 23.5)",
    fill: "#303030"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 16.5 12.5)",
    fill: "#303030"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 16.5 1.5)",
    fill: "#303030"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 27.5 23.5)",
    fill: "#303030"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 27.5 12.5)",
    fill: "#303030"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 27.5 1.5)",
    fill: "#303030"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 38.5 23.5)",
    fill: "#303030"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 38.5 12.5)",
    fill: "#303030"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 49.5 23.5)",
    fill: "#303030"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 60.5 23.5)",
    fill: "#303030"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 111.5,
    y: 23.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#303030"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 111.5,
    y: 12.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#303030"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 111.5,
    y: 1.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#303030"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 100.5,
    y: 23.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#303030"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 100.5,
    y: 12.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#303030"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 100.5,
    y: 1.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#303030"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 89.5,
    y: 23.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#303030"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 89.5,
    y: 12.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#303030"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 89.5,
    y: 1.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#303030"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 78.5,
    y: 23.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#303030"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 78.5,
    y: 12.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#303030"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 67.5,
    y: 23.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#303030"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 4.5 22.5)",
    fill: "#050505"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 4.5 11.5)",
    fill: "#050505"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 4.5 0.5)",
    fill: "#050505"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 15.5 22.5)",
    fill: "#050505"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 15.5 11.5)",
    fill: "#050505"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 15.5 0.5)",
    fill: "#050505"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 26.5 22.5)",
    fill: "#050505"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 26.5 11.5)",
    fill: "#050505"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 26.5 0.5)",
    fill: "#050505"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 37.5 22.5)",
    fill: "#050505"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 37.5 11.5)",
    fill: "#050505"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 48.5 22.5)",
    fill: "#050505"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 59.5 22.5)",
    fill: "#050505"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 110.5,
    y: 22.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#050505"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 110.5,
    y: 11.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#050505"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 110.5,
    y: 0.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#050505"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 99.5,
    y: 22.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#050505"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 99.5,
    y: 11.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#050505"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 99.5,
    y: 0.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#050505"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 88.5,
    y: 22.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#050505"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 88.5,
    y: 11.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#050505"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 88.5,
    y: 0.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#050505"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 77.5,
    y: 22.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#050505"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 77.5,
    y: 11.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#050505"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 22.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#050505"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 5 23)",
    fill: "url(#paint0_angular_706_9282)"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 5 23)",
    fill: "url(#paint1_linear_706_9282)"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 5 12)",
    fill: "url(#paint2_angular_706_9282)"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 5 12)",
    fill: "url(#paint3_linear_706_9282)"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 5 1)",
    fill: "url(#paint4_angular_706_9282)"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 5 1)",
    fill: "url(#paint5_linear_706_9282)"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 16 23)",
    fill: "url(#paint6_angular_706_9282)"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 16 23)",
    fill: "url(#paint7_linear_706_9282)"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 16 12)",
    fill: "url(#paint8_angular_706_9282)"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 16 12)",
    fill: "url(#paint9_linear_706_9282)"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 16 1)",
    fill: "url(#paint10_angular_706_9282)"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 16 1)",
    fill: "url(#paint11_linear_706_9282)"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 27 23)",
    fill: "url(#paint12_angular_706_9282)"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 27 23)",
    fill: "url(#paint13_linear_706_9282)"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 27 12)",
    fill: "url(#paint14_angular_706_9282)"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 27 12)",
    fill: "url(#paint15_linear_706_9282)"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 27 1)",
    fill: "url(#paint16_angular_706_9282)"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 27 1)",
    fill: "url(#paint17_linear_706_9282)"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 38 23)",
    fill: "url(#paint18_angular_706_9282)"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 38 23)",
    fill: "url(#paint19_linear_706_9282)"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 38 12)",
    fill: "url(#paint20_angular_706_9282)"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 38 12)",
    fill: "url(#paint21_linear_706_9282)"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 49 23)",
    fill: "url(#paint22_angular_706_9282)"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 49 23)",
    fill: "url(#paint23_linear_706_9282)"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 60 23)",
    fill: "url(#paint24_angular_706_9282)"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 60 23)",
    fill: "url(#paint25_linear_706_9282)"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 23,
    width: 4,
    height: 4,
    rx: 2,
    fill: "url(#paint26_angular_706_9282)"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 23,
    width: 4,
    height: 4,
    rx: 2,
    fill: "url(#paint27_linear_706_9282)"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 12,
    width: 4,
    height: 4,
    rx: 2,
    fill: "url(#paint28_angular_706_9282)"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 12,
    width: 4,
    height: 4,
    rx: 2,
    fill: "url(#paint29_linear_706_9282)"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 1,
    width: 4,
    height: 4,
    rx: 2,
    fill: "url(#paint30_angular_706_9282)"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 1,
    width: 4,
    height: 4,
    rx: 2,
    fill: "url(#paint31_linear_706_9282)"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 23,
    width: 4,
    height: 4,
    rx: 2,
    fill: "url(#paint32_angular_706_9282)"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 23,
    width: 4,
    height: 4,
    rx: 2,
    fill: "url(#paint33_linear_706_9282)"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 12,
    width: 4,
    height: 4,
    rx: 2,
    fill: "url(#paint34_angular_706_9282)"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 12,
    width: 4,
    height: 4,
    rx: 2,
    fill: "url(#paint35_linear_706_9282)"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 1,
    width: 4,
    height: 4,
    rx: 2,
    fill: "url(#paint36_angular_706_9282)"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 1,
    width: 4,
    height: 4,
    rx: 2,
    fill: "url(#paint37_linear_706_9282)"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 23,
    width: 4,
    height: 4,
    rx: 2,
    fill: "url(#paint38_angular_706_9282)"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 23,
    width: 4,
    height: 4,
    rx: 2,
    fill: "url(#paint39_linear_706_9282)"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 12,
    width: 4,
    height: 4,
    rx: 2,
    fill: "url(#paint40_angular_706_9282)"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 12,
    width: 4,
    height: 4,
    rx: 2,
    fill: "url(#paint41_linear_706_9282)"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 1,
    width: 4,
    height: 4,
    rx: 2,
    fill: "url(#paint42_angular_706_9282)"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 1,
    width: 4,
    height: 4,
    rx: 2,
    fill: "url(#paint43_linear_706_9282)"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 23,
    width: 4,
    height: 4,
    rx: 2,
    fill: "url(#paint44_angular_706_9282)"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 23,
    width: 4,
    height: 4,
    rx: 2,
    fill: "url(#paint45_linear_706_9282)"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 12,
    width: 4,
    height: 4,
    rx: 2,
    fill: "url(#paint46_angular_706_9282)"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 12,
    width: 4,
    height: 4,
    rx: 2,
    fill: "url(#paint47_linear_706_9282)"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 23,
    width: 4,
    height: 4,
    rx: 2,
    fill: "url(#paint48_angular_706_9282)"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 23,
    width: 4,
    height: 4,
    rx: 2,
    fill: "url(#paint49_linear_706_9282)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_706_9282",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2 2) rotate(-45) scale(2.82843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.250064,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497279,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75143,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752702,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_706_9282",
    x1: 2,
    y1: 0,
    x2: 2,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_angular_706_9282",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2 2) rotate(-45) scale(2.82843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.250064,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497279,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75143,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752702,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_706_9282",
    x1: 2,
    y1: 0,
    x2: 2,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_angular_706_9282",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2 2) rotate(-45) scale(2.82843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.250064,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497279,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75143,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752702,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_706_9282",
    x1: 2,
    y1: 0,
    x2: 2,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_angular_706_9282",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2 2) rotate(-45) scale(2.82843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.250064,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497279,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75143,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752702,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_706_9282",
    x1: 2,
    y1: 0,
    x2: 2,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_angular_706_9282",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2 2) rotate(-45) scale(2.82843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.250064,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497279,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75143,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752702,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_706_9282",
    x1: 2,
    y1: 0,
    x2: 2,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_angular_706_9282",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2 2) rotate(-45) scale(2.82843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.250064,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497279,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75143,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752702,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_706_9282",
    x1: 2,
    y1: 0,
    x2: 2,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_angular_706_9282",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2 2) rotate(-45) scale(2.82843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.250064,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497279,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75143,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752702,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_706_9282",
    x1: 2,
    y1: 0,
    x2: 2,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_angular_706_9282",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2 2) rotate(-45) scale(2.82843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.250064,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497279,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75143,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752702,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_706_9282",
    x1: 2,
    y1: 0,
    x2: 2,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_angular_706_9282",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2 2) rotate(-45) scale(2.82843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.250064,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497279,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75143,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752702,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_706_9282",
    x1: 2,
    y1: 0,
    x2: 2,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_angular_706_9282",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2 2) rotate(-45) scale(2.82843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.250064,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497279,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75143,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752702,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_706_9282",
    x1: 2,
    y1: 0,
    x2: 2,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_angular_706_9282",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2 2) rotate(-45) scale(2.82843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.250064,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497279,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75143,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752702,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_706_9282",
    x1: 2,
    y1: 0,
    x2: 2,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_angular_706_9282",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2 2) rotate(-45) scale(2.82843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.250064,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497279,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75143,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752702,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_706_9282",
    x1: 2,
    y1: 0,
    x2: 2,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_angular_706_9282",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2 2) rotate(-45) scale(2.82843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.250064,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497279,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75143,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752702,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_706_9282",
    x1: 2,
    y1: 0,
    x2: 2,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_angular_706_9282",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113 25) rotate(-45) scale(2.82843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.250064,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497279,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75143,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752702,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_706_9282",
    x1: 113,
    y1: 23,
    x2: 113,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_angular_706_9282",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113 14) rotate(-45) scale(2.82843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.250064,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497279,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75143,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752702,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_706_9282",
    x1: 113,
    y1: 12,
    x2: 113,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_angular_706_9282",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113 3) rotate(-45) scale(2.82843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.250064,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497279,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75143,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752702,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_706_9282",
    x1: 113,
    y1: 1,
    x2: 113,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_angular_706_9282",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(102 25) rotate(-45) scale(2.82843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.250064,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497279,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75143,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752702,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_706_9282",
    x1: 102,
    y1: 23,
    x2: 102,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_angular_706_9282",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(102 14) rotate(-45) scale(2.82843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.250064,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497279,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75143,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752702,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_706_9282",
    x1: 102,
    y1: 12,
    x2: 102,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_angular_706_9282",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(102 3) rotate(-45) scale(2.82843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.250064,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497279,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75143,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752702,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_706_9282",
    x1: 102,
    y1: 1,
    x2: 102,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_angular_706_9282",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91 25) rotate(-45) scale(2.82843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.250064,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497279,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75143,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752702,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_706_9282",
    x1: 91,
    y1: 23,
    x2: 91,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_angular_706_9282",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91 14) rotate(-45) scale(2.82843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.250064,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497279,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75143,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752702,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_706_9282",
    x1: 91,
    y1: 12,
    x2: 91,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_angular_706_9282",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91 3) rotate(-45) scale(2.82843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.250064,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497279,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75143,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752702,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_706_9282",
    x1: 91,
    y1: 1,
    x2: 91,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_angular_706_9282",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80 25) rotate(-45) scale(2.82843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.250064,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497279,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75143,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752702,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_706_9282",
    x1: 80,
    y1: 23,
    x2: 80,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_angular_706_9282",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80 14) rotate(-45) scale(2.82843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.250064,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497279,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75143,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752702,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_706_9282",
    x1: 80,
    y1: 12,
    x2: 80,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_angular_706_9282",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69 25) rotate(-45) scale(2.82843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.250064,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497279,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75143,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752702,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_706_9282",
    x1: 69,
    y1: 23,
    x2: 69,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/Speaker.723eec194cda0ae95a135629fea1c370.svg";
export { ForwardRef as ReactComponent };